import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleMainInfo } from 'Pages/vehicles/helpers/vehicle.schema';

export const useVehicleMainInfo = (): VehicleMainInfo => {
	const { mainInfo } = useVehicleData();

	return mainInfo;
};
